import { putTechnicalAssistanceModule } from '../../config/apiSinToken'

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Technical Assistance implementation activities
 * FECHA: 03-02-2023
 */
export const updateTechnicalAssistanceImplementationActivities = async (
  form,
) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/ImplementationActivities/update`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Technical Assistance implementation received
 * FECHA: 14-02-2023
 */
export const updateTechnicalAssistanceReceived = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceReceived/update`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Indigenous Communities
 * FECHA: 14-02-2023
 */
export const updateIndigenousCommunities = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/IndigenousCommunities/update`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Technical Assistance Budget
 * FECHA: 14-02-2023
 */
export const updateTechnicalAssistanceBudget = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/update`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Technical Assistance Applican
 * FECHA: 14-02-2023
 */
export const updateTechnicalAssistanceApplicant = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceApplicant/update`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Applied studies
 * FECHA: 23-02-2023
 */
export const updateAppliedStudies = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/AppliedStudies/UpdateAppliedStudies`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: update Provider List
 * FECHA: 13-03-2023
 */
export const updateProviderList = async (form) => {
  const data = await putTechnicalAssistanceModule(
    `api/v1/ProviderList/update`,
    form,
  )
  return data
}
